import { b as getLookupValuePageTabs } from './lookups-705fb53e.js';
import { u as updatePageLoadData } from './send-33ade633.js';

const setArticleTitle = (articleTitle) => {
    updatePageLoadData({ articleTitle: getLookupValuePageTabs(articleTitle) });
};
const isAnalyticsEnabled = () => !window.analyticsDisabled;

export { isAnalyticsEnabled as i, setArticleTitle as s };
